import React, { ReactNode } from 'react';
import { CrieSeuRoteiroContext } from './index';

interface PacoteDetailProviderProps {
  data: FormCreateJourneyDataPageType;
  children?: ReactNode;
}
const CrieSeuRoteiroProvider = ({ data, children }: PacoteDetailProviderProps) => {
  return <CrieSeuRoteiroContext.Provider value={{ data }}>{children}</CrieSeuRoteiroContext.Provider>;
};

export default CrieSeuRoteiroProvider;
